import { useQuery } from '@tanstack/react-query';

import { freePassQueries } from '../api/freePassQueries';
import useFreePassEnabled from './useFreePassEnabled';
import useFreePassUserId from './useFreePassUserId';

const usePromoItemsQuery = (promoId: string | undefined) => {
  const enabled = useFreePassEnabled();
  const userId = useFreePassUserId();

  // The user-id guard is the auth gate: this endpoint 401s without a token.
  // `useStreakState` also withholds the promo id for guests — either alone
  // keeps the request unsent.
  return useQuery({
    ...freePassQueries.items({ userId, promoId: promoId ?? '' }),
    enabled: enabled && Boolean(userId) && Boolean(promoId),
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};

export default usePromoItemsQuery;
